import React, {forwardRef} from 'react';
import { default as benefit1 } from '../../../images/Creative_Comm_benefit_1.svg';
import { default as benefit2 } from '../../../images/Creative_Comm_benefit_2.svg';
import useCreativeBenefits from '../../hooks/useCreativeBenefits';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import './CreativeMemberBenefit.scss';

const CreativeMemberBenefit = forwardRef((props, ref) => {

  const onJoinParty = () =>  window.open(`https://www.noissue.co/creative-account-application/`, '_blank', 'noopener');
  const data = useCreativeBenefits();

  const {
    allContentfulCreativeCommunityMemberBenefits : { edges : benefits }
  } = data;

    
  return (
    <div className="creative-member-benefit-container" ref={ref}>
      <div className="creative-member-benefit-heading">
        <div className="creative-member-benefit-title">
          Member Benefits
        </div>
        <div className="creative-member-benefit-subtitle">
          Are you a Creative and interested in joining the Community? Here’s why you 100% should:
        </div>
      </div>
      <div className="creative-member-benefit-details">
        {
          benefits.map((benefit, idx) => {
            return <div key={`benefit-${idx}`} className="creative-member-benefit-details-box">
            <CommunityImg src={benefit.node.creativeBenefitImage.file.url} alt="benefit1" />
            <div className="creative-member-benefit-details-box-title">
              {benefit.node.creativeBenefitTitle}
            </div>
            <div className="creative-member-benefit-details-box-subtitle">
            {benefit.node.creativeBenefitDescription}
            </div>
          </div>
          })
        }
      </div>
      <div className="creative-member-benefit-image-container">
        <div className="creative-member-benefit-image-benefit1">
          <CommunityImg src={benefit1} alt="benefit1" />
        </div>
        <div className="creative-member-benefit-image-details">
          <div className="creative-member-benefit-image-button">
            <button onClick={onJoinParty}>Join Now</button>
          </div>
          <div className="creative-member-benefit-image-title">
            Still have questions? Shoot us a note at creatives@noissue.co
          </div>
        </div>
        <div className="creative-member-benefit-image-benefit2">
          <CommunityImg src={benefit2} alt="benefit2" />
        </div>
      </div>
    </div>
  )
});

export default CreativeMemberBenefit;
